import React from 'react';
import { LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export default function FeatureCard({ icon, title, description }: FeatureCardProps) {
  return (
    <div className="group bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 max-h-[400px] overflow-auto">
      <div className="mb-4 transform transition-transform duration-300 group-hover:scale-110">
        {icon}
      </div>
      <h3 className="text-2xl font-semibold text-[--c-dark] mb-3">{title}</h3>
      {description.split('\n').map((line, index) => (
        <p className="text-main text-xl leading-relaxed" key={index}>{line}</p>
      ))}
    </div>
  );
}